export default {
  serverURI: {
    'development': 'http://localhost:5934/api',
    'production': '/api'
  },
  version: process.env.VUE_APP_APP_CURR_VERSION
}
